import { setModal } from '../../../../app/store/reducers/AppSlice'
import { AddProjectModal } from '../../../../pages/projects/widgets/add-project-modal/AddProjectModal'
import { IconArrowRight } from '../../icons/IconArrowRight'
import React from 'react'
import { useAppDispatch, useAppSelector } from '../../../../app/store/hooks/Redux'
import { useTranslation } from 'react-i18next'
import { selectTariffDetails } from '../../../../app/store/reducers/AuthSlice'
import { ViewGuard } from '../../../../app/guards/ViewGuard'

export const AddProjectButton = () => {
  const { t } = useTranslation()
  const tariffDetails = useAppSelector(selectTariffDetails)
  const dispatch = useAppDispatch()

  return (
    <ViewGuard roles={['admin', 'editor']}>
      <button
        className={`flex w-full items-center justify-between px-[16px] py-[8px] text-default ${tariffDetails.tariff?.is_subscription_expired && 'cursor-not-allowed opacity-30'} `}
        disabled={tariffDetails.tariff?.is_subscription_expired}
        type={'button'}
        onClick={() => dispatch(setModal({ children: <AddProjectModal /> }))}
      >
        {t('buttons.createNewProject')}
        <div className={'w-[14px]'}>
          <IconArrowRight color={'#A059FF'} />
        </div>
      </button>
    </ViewGuard>
  )
}
